module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QMGR6P/tc-custom/9781460338650.jpg?1701746588720",
      "alt": "This image is the cover for the book Ultimate Revenge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ultimate Revenge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("\"I will annihilate your world. As you destroyed mine.\"")]), _c('b'), _c('br'), _c('br'), _vm._v("For over a decade Nicandro Santos, heir to a legendary diamond legacy, has lived with one unrelenting purpose: to infiltrate the ultraprestigious Q Virtus gentleman's club and bring it, and its leader, Zeus, down. "), _c('br'), _c('br'), _vm._v("What he doesn't know is that Olympia Merisi, the daughter of his enemy, is now in charge. Olympia has her own reasons for wanting to keep Nicandro close, and she will stop at nothing to protect what's hers. But what happens when the battle lines between them blur and they enter more dangeroussensualterritory?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victoria Parker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("After years of stifling her writers muse and acquiring various uninspiring job-titles, Victoria Parker finally surrended to that persistant voice and penned her first M&B romance. Turns out, creating havoc for feisty heroines and devilish heroes truly is the best job in the world. In her spare time she dabbles in interior design, loves discovering far flung destinations and getting into mischief with her rather wonderful family.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0